import { LiteModeToggle } from "./mode-toggle";

export default function () {
  return <LiteModeToggle />;
}
